export enum AuthType {
	NotLoggedIn,
	User,
	SuperAdmin
}
